// @avantia common-code
import { Policy } from '../types/policyTypes';
import { createMockPolicy, mockSpecifiedItems, noAddonDetails } from './shared';

export const label = 'Buildings & Contents - Florence';

export const policy: Policy = createMockPolicy({
  policyNumber: 'C12/44455566',
  policyDetailsId: '124445556666',
  coverType: 'Buildings & Contents',
  productDescription: 'Florence',
  accidentalDamageLevel: { Buildings: 'Full', Contents: 'Full' },
  specifiedItems: mockSpecifiedItems,
  addonDetails: noAddonDetails
});
